import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

function Callback() {
  const loc = useLocation();

  useEffect(() => {
    const fullUrl = window.location.href;
    fetch(`/api/sendMail?route=${encodeURIComponent(fullUrl)}`);
  }, [loc]);

  return <p>Procesando callback…</p>;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/callback" element={<Callback />} />
        <Route path="*" element={<p>Bienvenido a callback-app</p>} />
      </Routes>
    </BrowserRouter>
  );
}
